const messages = {
  en: {
    translations: {
      signup: {
        title: "Sign Up",
        toasts: {
          success: "User created successfully! Log in now!!!",
          fail: "Error creating user. Please check the provided information.",
        },
        form: {
          name: "Name",
          email: "Email",
          password: "Password",
          company: "Organization Name",
          phone: "WhatsApp (AREA CODE + NUMBER)",
        },
        buttons: {
          submit: "Register",
          login: "Already have an account? Log in!",
        },
      },
      login: {
        title: "Login",
        form: {
          email: "Email",
          password: "Password",
          button: "Access",
        },
        buttons: {
          submit: "Log In",
          register: "Don't have an account? Sign up!",
        },
      },
      companies: {
        title: "Register Company",
        form: {
          name: "Company Name",
          plan: "Plan",
          token: "Token",
          submit: "Register",
          success: "Company created successfully!",
        },
      },
      auth: {
        toasts: {
          success: "Login successful!",
        },
        dueDate: {
          expiration: "Your subscription expires in",
          days: "days!",
          day: "day!",
          expirationToday: "Your subscription expires today!",
        },
        token: "Token",
      },
      dashboard: {
        title: "Dashboard",
        buttons: {
          filter: "Filter"
        },
        tabs: {
          indicators: "Indicators",
          assessments: "NPS",
          attendants: "Agents",
          performance: "Performances"
        },
        charts: {
          perDay: {
            title: "Services today: ",
          },
        },
        cards: {
          inAttendance: "In Service",
          waiting: "Waiting",
          activeAttendants: "Active Agents",
          finalized: "Completed",
          newContacts: "New Contacts",
          totalReceivedMessages: "Messages Received",
          totalSentMessages: "Messages Sent",
          averageServiceTime: "Avg. Service Time",
          averageWaitingTime: "Avg. Waiting Time",
          status: "Status (Current)",
          activeTickets: "Active Tickets",
          passiveTickets: "Passive Tickets",
          groups: "Groups",
        },
        users: {
          name: "Name",
          numberAppointments: "Number of Services",
          statusNow: "Current",
          totalCallsUser: "Total services per user",
          totalAttendances: "Total services",
          totalLabel: "Total attendances: {{count}}",
          queues: "Queues",
          defaultQueue: "Default Connection",
          workingHours: "Working Hours",
          startWork: "Start Work",
          endWork: "End Work",
          farewellMessage: "Farewell Message",
          theme: "Default Theme",
          menu: "Default Menu",
        },
        date: {
          initialDate: "Start Date",
          finalDate: "End Date",
        },
        licence: {
          available: "Available until",
        },
        assessments: {
          totalCalls: "Total Services",
          callsWaitRating: "Services awaiting rating",
          callsWithoutRating: "Services without rating",
          ratedCalls: "Rated Services",
          evaluationIndex: "Evaluation Index",
          score: "Score",
          prosecutors: "Promoters",
          neutral: "Neutral",
          detractors: "Detractors",
        },
      },
      reports: {
        title: "Survey Reports",
        operator: "Operator",
        period: "Period",
        until: "Until",
        date: "Date",
        reportTitle: "Reports",
        calls: "Services",
        search: "Surveys",
        durationCalls: "Service Duration",
        grupoSessions: "Group Services",
        groupTicketsReports: {
          timezone: "America/Sao_Paulo",
          msgToast: "Generating compressed report, please wait.",
          errorToast: "Error generating report",
          back: "Back",
          groupServiceReport: "Group Service Report",
          loading: "Loading...",
          contact: "Contact",
          dateOpen: "Opening Date",
          dateLastUpdated: "Last Updated Date",
          agent: "Who Attended",
          agentClosed: "Who Closed",
          waitingAssistance: "Awaiting Assistance",
          process: "In Service",
        },
        researchReports: {
          response: "response",
          active: "(Active)",
          inactive: "(Inactive)",
          quantity: "Quantity",
          percentage: "percentage",
          title: "Survey Reports",
          activeSearch: "Active Survey",
          inactiveSearch: "Inactive Survey",
        },
        ticketDurationDetail: {
          msgToast: "Generating compressed report, please wait.",
          title: "Service Duration Report",
          startService: "Service Start",
          lastUpdated: "Last Updated",
          lastAgent: "Last Agent",
          durationFinished: "Duration After Completion",
        },
        ticketDuration: {
          title: "Service Duration Report",
          contact: "Contact",
          open: "Open",
          pending: "Pending",
          finished: "Completed",
          durationFinished: "Completed Duration",
          durationAfterFinished: "Duration After Completion",
          actions: "Actions",
        },
        ticketReports: {
          msgToast: "Generating compressed report, please wait.",
          title: "Service Report",
        },
        pdf: {
          title: "List of Completed Services",
          exportTitle: "List of Completed Group Services",
        },
      },
      todo: {
        newTask: "New Task",
        add: "Add",
        task: "Tasks",
      },
      contactImportWpModal: {
        title: "Export Contacts to Excel",
        buttons: {
          downloadModel: "Download Excel template for import",
          closed: "Close",
          import: "Select the Excel file to import Contacts",
        },
      },
      connections: {
        title: "Connections",
        waitConnection: "Wait... Your connections will be restarted!",
        newConnection: "New Connection",
        restartConnections: "Restart Connections",
        callSupport: "Call Support",
        toasts: {
          deleted: "Connection deleted successfully!",
          closedimported:
            "We are closing the imported tickets, please wait a moment",
        },
        confirmationModal: {
          closedImportedTitle: "Close imported tickets",
          closedImportedMessage:
            "If you confirm, all imported tickets will be closed",
          deleteTitle: "Delete",
          deleteMessage: "Are you sure? This action cannot be undone.",
          disconnectTitle: "Disconnect",
          disconnectMessage:
            "Are you sure? You will need to scan the QR code again.",
        },
        buttons: {
          add: "Add Connection",
          disconnect: "disconnect",
          tryAgain: "Try Again",
          qrcode: "QR CODE",
          newQr: "NEW QR CODE",
          closedImported: "Close all Imported tickets",
          preparing: "Preparing messages for import",
          importing: "Importing WhatsApp Messages",
          processed: "Processed",
          in: "of",
          connecting: "Connecting",
        },
        typography: {
          processed: "Processed",
          in: "of",
          date: "Message date",
        },
        toolTips: {
          disconnected: {
            title: "Failed to start WhatsApp session",
            content:
              "Ensure your phone is connected to the internet and try again, or request a new QR code",
          },
          qrcode: {
            title: "Waiting for QR code scan",
            content:
              "Click the 'QR CODE' button and scan the QR code with your phone to start the session",
          },
          connected: {
            title: "Connection established!",
          },
          timeout: {
            title: "Connection to the phone was lost",
            content:
              "Ensure your phone is connected to the internet and WhatsApp is open, or click 'Disconnect' to get a new QR code",
          },
        },
        table: {
          name: "Name",
          status: "Status",
          lastUpdate: "Last Update",
          default: "Default",
          actions: "Actions",
          session: "Session",
          number: "WhatsApp Number",
        },
      },
      showTicketOpenModal: {
        title: {
          header: "Existing Service",
        },
        form: {
          message: "This contact is already being served:",
          user: "Agent",
          queue: "Queue",
          messageWait:
            "This contact is already waiting for service. Check the Waiting tab!",
        },
      },
      showTicketLogModal: {
        title: {
          header: "Logs",
        },
        options: {
          create: "Ticket created.",
          chatBot: "ChatBot started.",
          queue: " - Queue defined.",
          open: " started the service.",
          access: "accessed the ticket.",
          transfered: "transferred the ticket.",
          receivedTransfer: "received the transferred ticket.",
          pending: "returned to queue.",
          closed: "closed the ticket",
          reopen: "reopened the ticket",
          redirect: "- redirected"
        },
      },
      whatsappModal: {
        title: {
          add: "Add Connection",
          edit: "Edit Connection",
        },
        tabs: {
          general: "General",
          messages: "Messages",
          assessments: "NPS",
          integrations: "Integrations",
          schedules: "Business Hours",
        },
        form: {
          importOldMessagesEnable: "Import messages from device",
          importOldMessages: "Import start date",
          importRecentMessages: "Import end date",
          importOldMessagesGroups: "Import group messages",
          closedTicketsPostImported: "Close tickets after import",
          name: "Name",
          queueRedirection: "Queue Redirection",
          queueRedirectionDesc:
            "Select a queue to redirect contacts without an assigned queue",
          default: "Default",
          group: "Allow groups",
          timeSendQueue: "Time in minutes to redirect to queue",
          importAlert:
            "ATTENTION: Upon saving, your connection will be closed, and you will need to scan the QR code again to import messages",
          groupAsTicket: "Treat groups as tickets",
          timeCreateNewTicket: "Create new ticket in x minutes",
          maxUseBotQueues: "Send bot x times",
          timeUseBotQueues: "Send bot in x minutes",
          expiresTicket: "Close open chats after x minutes",
          expiresTicketNPS:
            "Close chats awaiting rating after x minutes",
          maxUseBotQueuesNPS:
            "Maximum number of times the rating will be sent",
          closeLastMessageOptions1: "From agent/Client",
          closeLastMessageOptions2: "From agent",
          outOfHoursMessage: "Out-of-hours message",
          lunchHourMessage: "Lunch hour message",
          greetingMessage: "Greeting message",
          complationMessage: "Completion message",
          lgpdLinkPrivacy: "Privacy policy link",
          lgpdMessage: "LGPD greeting message",
          lgpdDeletedMessages: "Hide message deleted by contact",
          lgpdSendMessage: "Always request contact confirmation",
          ratingMessage: "Rating message - Scale must be from 0 to 10",
          token: "Token for external integration",
          sendIdQueue: "Queue",
          inactiveMessage: "Inactivity message",
          timeInactiveMessage:
            "Time in minutes to send inactivity warning",
          whenExpiresTicket:
            "Close open chats when the last message is",
          expiresInactiveMessage: "Inactivity closure message",
          prompt: "Prompt",
          collectiveVacationEnd: "End date",
          collectiveVacationStart: "Start date",
          collectiveVacationMessage: "Collective vacation message",
          queueIdImportMessages: "Queue to import messages"
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        menuItem: {
          enabled: "Enabled",
          disabled: "Disabled",
          minutes: "minutes",
        },
        success: "Connection saved successfully.",
        errorSendQueue:
          "A time to redirect to queue was provided, but no queue was selected. Both fields must be filled.",
        errorExpiresNPS:
          "You must specify a time for rating when using NPS.",
        errorRatingMessage:
          "You must provide a rating message when using NPS.",
      },
      qrCode: {
        message: "Scan the QR code to start the session",
      },
      contacts: {
        title: "Contacts",
        toasts: {
          deleted: "Contact deleted successfully!",
        },
        searchPlaceholder: "Search...",
        confirmationModal: {
          deleteTitle: "Delete ",
          importTitlte: "Import contacts",
          exportContact: "Export contacts",
          deleteMessage:
            "Are you sure you want to delete this contact? All related services will be lost.",
          blockContact: "Are you sure you want to block this contact?",
          unblockContact: "Are you sure you want to unblock this contact?",
          importMessage: "Do you want to import all contacts from the phone?",
          importChat: "Import Chats",
          wantImport: "Do you want to import all chats from the phone?",
        },
        buttons: {
          import: "Import Contacts",
          add: "Add Contact",
          export: "Export Contact",
        },
        table: {
          name: "Name",
          whatsapp: "Connection",
          email: "Email",
          actions: "Actions",
          lastMessage: "Last Message",
        },
        menu: {
          importYourPhone: "Import from default device",
          importToExcel: "Import/Export from Excel",
        },
      },
      forwardMessage: {
        text: "Forwarded",
      },
      forwardMessageModal: {
        title: "Forward message",
        buttons: {
          ok: "Forward",
        },
      },
      promptModal: {
        form: {
          name: "Name",
          prompt: "Prompt",
          voice: "Voice",
          max_tokens: "Maximum Tokens in response",
          temperature: "Temperature",
          apikey: "API Key",
          max_messages: "Maximum messages in History",
          voiceKey: "Voice API Key",
          voiceRegion: "Voice Region",
        },
        success: "Prompt saved successfully!",
        title: {
          add: "Add Prompt",
          edit: "Edit Prompt",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
      },
      prompts: {
        title: "Prompts",
        table: {
          name: "Name",
          queue: "Department/Queue",
          max_tokens: "Maximum Response Tokens",
          actions: "Actions",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "Are you sure? This action cannot be undone!",
        },
        buttons: {
          add: "Add Prompt",
        },
      },
      contactModal: {
        title: {
          add: "Add contact",
          edit: "Edit contact",
        },
        form: {
          mainInfo: "Contact details",
          extraInfo: "Additional information",
          name: "Name",
          number: "WhatsApp Number",
          email: "Email",
          extraName: "Field name",
          extraValue: "Value",
          chatBotContact: "Disable chatbot",
          termsLGDP: "LGPD terms accepted on:",
          whatsapp: "Source Connection: "
        },
        buttons: {
          addExtraInfo: "Add information",
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "Contact saved successfully.",
      },
      flowbuilder: {
        title: "Flowbuilder",
        subMenus: {
          campaign: "Campaign Flow",
          conversation: "Conversation Flow"
        }
      },
      flowbuilderModal: {
        flowNotIdPhrase: "Default flow",
      },
      queueModal: {
        title: {
          queueData: "Queue data",
          text: "Service hours",
          add: "Add queue",
          edit: "Edit queue",
          confirmationDelete:
            "Are you sure? All integration options will be deleted.",
        },
        form: {
          name: "Name",
          color: "Color",
          orderQueue: "Queue order (Bot)",
          rotate: "Rotation",
          timeRotate: "Rotation Time",
          greetingMessage: "Greeting message",
          complationMessage: "Completion message",
          outOfHoursMessage: "Out-of-hours message",
          lunchHourMessage: "Lunch hour message",
          isBoletoQueue: "Is Boleto Second Copy Queue",
          boletoPromptMessage: "Document prompt message (CNPJ/CPF)",
          token: "Token",
          integrationId: "Integration",
          fileListId: "File list",
          closeTicket: "Close ticket",
          queueType: "Menu type",
          message: "Return message",
          queue: "Queue for transfer",
          integration: "Integration",
          file: "File list",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        bot: {
          title: "Options",
          toolTipTitle: "Add options to build a chatbot",
          toolTip:
            "If there is only one option, it will be chosen automatically, causing the bot to respond with the option's message and proceed",
          selectOption: "Select an option",
          text: "Text",
          attendent: "Agent",
          queue: "Queue",
          integration: "Integration",
          file: "File",
          toolTipMessageTitle:
            "The message is mandatory to proceed to the next level",
          toolTipMessageContent:
            "The message is mandatory to proceed to the next level",
          selectUser: "Select a User",
          selectQueue: "Select a Queue",
          selectIntegration: "Select an Integration",
          addOptions: "Add options",
        },
        serviceHours: {
          dayWeek: "Day of the week",
          startTimeA: "Start Time - Shift A",
          endTimeA: "End Time - Shift A",
          startTimeB: "Start Time - Shift B",
          endTimeB: "End Time - Shift B",
          monday: "Monday",
          tuesday: "Tuesday",
          wednesday: "Wednesday",
          thursday: "Thursday",
          friday: "Friday",
          saturday: "Saturday",
          sunday: "Sunday",
        },
      },
      queueIntegrationModal: {
        title: {
          add: "Add project",
          edit: "Edit project",
        },
        form: {
          id: "ID",
          type: "Type",
          name: "Name",
          projectName: "Project Name",
          language: "Language",
          jsonContent: "JsonContent",
          urlN8N: "URL",
          typebotSlug: "Typebot - Slug",
          typebotExpires: "Time in minutes for a conversation to expire",
          typebotKeywordFinish: "Word to close the ticket",
          typebotKeywordRestart: "Word to restart the flow",
          typebotRestartMessage: "Message on restarting the conversation",
          typebotUnknownMessage: "Invalid option message",
          typebotDelayMessage: "Interval (ms) between messages",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
          test: "Test Bot",
        },
        messages: {
          testSuccess: "Integration tested successfully!",
          addSuccess: "Integration added successfully.",
          editSuccess: "Integration edited successfully.",
        },
      },
      userModal: {
        warning:
          "To import messages, you need to scan the QR code again!!!",
        title: {
          add: "Add user",
          edit: "Edit user",
          updateImage: "Update image",
          removeImage: "Delete image",
        },
        form: {
          name: "Name",
          none: "None",
          email: "Email",
          password: "Password",
          farewellMessage: "Farewell message",
          profile: "Profile",
          startWork: "Work start",
          endWork: "Work end",
          whatsapp: "Default Connection",
          allTicketEnable: "Enabled",
          allTicketDisable: "Disabled",
          allTicket: "View tickets without queue",
          allowGroup: "Allow Groups",
          defaultMenuOpen: "Open",
          defaultMenuClosed: "Closed",
          defaultMenu: "Default menu",
          defaultTheme: "Default Theme",
          defaultThemeDark: "Dark",
          defaultThemeLight: "Light",
          allHistoric: "View conversations from other queues",
          allHistoricEnabled: "Enabled",
          allHistoricDisabled: "Disabled",
          allUserChat: "View other users' conversations",
          userClosePendingTicket: "Allow closing pending tickets",
          showDashboard: "View Dashboard",
          allowRealTime: "View Service Panel",
          allowConnections: "Allow actions on connections",
        },
        tabs: {
          general: "General",
          permissions: "Permissions",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
          addImage: "Add Image",
          editImage: "Edit Image",
        },
        success: "User saved successfully.",
      },
      companyModal: {
        title: {
          add: "Add company",
          edit: "Edit company",
        },
        form: {
          name: "Name",
          email: "Email",
          passwordDefault: "Password",
          numberAttendants: "Users",
          numberConections: "Connections",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "Company saved successfully.",
      },
      scheduleModal: {
        title: {
          add: "New Schedule",
          edit: "Edit Schedule",
        },
        form: {
          body: "Message",
          contact: "Contact",
          sendAt: "Schedule Date",
          sentAt: "Sent Date",
          assinar: "Send Signature"
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
          addSchedule: "Add schedule"
        },
        success: "Schedule saved successfully.",
      },
      tagModal: {
        title: {
          add: "New Tag",
          edit: "Edit Tag",
          addKanban: "New Lane",
          editKanban: "Edit Lane",
        },
        form: {
          name: "Name",
          color: "Color",
          timeLane: "Time in hours to redirect to lane",
          nextLaneId: "Lane",
          greetingMessageLane: "Lane greeting message",
          rollbackLaneId: "Return to Lane after resuming service"
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "Tag saved successfully.",
        successKanban: "Lane saved successfully.",
      },
      fileModal: {
        title: {
          add: "Add file list",
          edit: "Edit file list",
        },
        buttons: {
          okAdd: "Save",
          okEdit: "Edit",
          cancel: "Cancel",
          fileOptions: "Add file",
        },
        form: {
          name: "File list name",
          message: "List details",
          fileOptions: "File list",
          extraName: "Message to send with file",
          extraValue: "Option value",
        },
        success: "File list saved successfully!",
      },
      chat: {
        noTicketMessage: "Select a ticket to start chatting.",
      },
      uploads: {
        titles: {
          titleUploadMsgDragDrop:
            "⬇️ DRAG AND DROP FILES IN THE FIELD BELOW ⬇️",
          titleFileList: "File(s) list",
        },
      },
      chatInternal: {
        new: "New",
        modal: {
          conversation: "Conversation",
          title: "Title",
          filterUsers: "Filter by Users",
          cancel: "Close",
          save: "Save",
        },
        modalDelete: {
          title: "Delete Conversation",
          message: "This action cannot be undone, confirm?",
        },
      },
      ticketsManager: {
        questionCloseTicket: "DO YOU WANT TO CLOSE ALL TICKETS?",
        yes: "YES",
        not: "NO",
        buttons: {
          newTicket: "New",
          resolveAll: "Resolve All",
          close: "Close",
          new: "New",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Queues",
      },
      tickets: {
        inbox: {
          closedAllTickets: "Close all tickets?",
          closedAll: "Close All",
          newTicket: "New Ticket",
          yes: "YES",
          no: "NO",
          open: "Open",
          resolved: "Resolved",
        },
        toasts: {
          deleted: "The service you were in was deleted.",
        },
        notification: {
          message: "Message from",
        },
        tabs: {
          open: { title: "Open" },
          closed: { title: "Resolved" },
          search: { title: "Search" },
        },
        search: {
          placeholder: "Search services and messages",
          filterConnections: "Filter by Connection",
          filterConnectionsOptions: {
            open: "Open",
            closed: "Closed",
            pending: "Pending",
          },
          filterUsers: "Filter by Users",
          filterContacts: "Filter by Contacts",
          ticketsPerPage: "Tickets per page",
        },
        buttons: {
          showAll: "All",
          returnQueue: "Return to Queue",
          schedule: "Schedule",
          deleteTicket: "Delete Ticket",
        },
        closedTicket: {
          closedMessage: "Close Ticket with Farewell Message",
          closedNotMessage: "Close Ticket without Farewell Message",
        },
      },
      transferTicketModal: {
        title: "Transfer Ticket",
        fieldLabel: "Type to search for users",
        fieldQueueLabel: "Transfer to queue",
        fieldQueuePlaceholder: "Select a queue",
        fieldWhatsapp: "Select a WhatsApp",
        noOptions: "No user found with this name",
        msgTransfer: "Notes - internal message, not sent to the client",
        buttons: {
          ok: "Transfer",
          cancel: "Cancel",
        },
      },
      ticketsList: {
        called: "Called",
        today: "Today",
        missedCall: "Missed voice/video call at",
        pendingHeader: "Waiting",
        assignedHeader: "Serving",
        groupingHeader: "Groups",
        noTicketsTitle: "Nothing here!",
        noTicketsMessage:
          "No service found with this status or search term",
        noQueue: "No Queue",
        buttons: {
          accept: "Accept",
          cancel: "Cancel",
          start: "start",
          closed: "Close",
          reopen: "Reopen",
          transfer: "Transfer",
          ignore: "Ignore",
          exportAsPDF: "Export to PDF",
          kanbanActions: "Kanban Options"
        },
        acceptModal: {
          title: "Accept Chat",
          queue: "Select department",
        },
      },
      newTicketModal: {
        title: "Create Ticket",
        fieldLabel: "Type to search for contact",
        add: "Add",
        buttons: {
          ok: "Save",
          cancel: "Cancel",
        },
      },
      SendContactModal: {
        title: "Send contact",
        fieldLabel: "Type to search for contact",
        add: "Add",
        buttons: {
          ok: "Send",
          cancel: "Cancel",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          connections: "Connections",
          chatsTempoReal: "Panel",
          tickets: "Services",
          quickMessages: "Quick Responses",
          contacts: "Contacts",
          queues: "Queues & Chatbot",
          flowbuilder: "Flowbuilder",
          tags: "Tags",
          administration: "Administration",
          companies: "Companies",
          users: "Users",
          settings: "Settings",
          files: "File List",
          helps: "Help",
          messagesAPI: "API",
          schedules: "Schedules",
          campaigns: "Campaigns",
          announcements: "Announcements",
          chats: "Internal Chat",
          financeiro: "Financial",
          queueIntegration: "Integrations",
          version: "Version",
          kanban: "Kanban",
          prompts: "Talk.Ai",
          allConnections: "Manage connections",
          reports: "Reports",
          management: "Management"
        },
        appBar: {
          user: {
            profile: "Profile",
            logout: "Log out",
            message: "Hello",
            messageEnd: "welcome to",
            active: "Active until",
            goodMorning: "Hi,",
            myName: "my name is",
            continuity: "and I will continue your service.",
            virtualAssistant: "Virtual Assistant",
            token:
              "Invalid token, please contact the platform administrator.",
          },
          message: {
            location: "Location",
            contact: "Contact",
          },
          notRegister: "No record",
          refresh: "Refresh",
        },
      },
      languages: {
        undefined: "Language",
        "pt-BR": "Portuguese",
        es: "Spanish",
        en: "English",
        tr: "Turkish",
      },
      messagesAPI: {
        title: "API",
        textMessage: {
          number: "Number",
          body: "Message",
          token: "Registered Token",
          userId: "User/Agent ID",
          queueId: "Queue ID",
        },
        mediaMessage: {
          number: "Number",
          body: "File name",
          media: "File",
          token: "Registered Token",
        },
        API: {
          title: "Documentation for sending messages",
          methods: {
            title: "Sending Methods",
            messagesText: "Text Messages",
            messagesMedia: "Media Messages",
          },
          instructions: {
            title: "Instructions",
            comments: "Important Notes",
            comments1:
              "Before sending messages, you must register the token linked to the connection that will send the messages. <br />To register, go to the 'Connections' menu, click the edit button for the connection, and enter the token in the appropriate field.",
            comments2:
              "The number for sending must not have a mask or special characters and must consist of:",
            codeCountry: "Country Code",
            code: "Area Code",
            number: "Number",
          },
          text: {
            title: "1. Text Messages",
            instructions:
              "Below is the list of information required to send text messages:",
          },
          media: {
            title: "2. Media Messages",
            instructions:
              "Below is the list of information required to send media messages:",
          },
        },
      },
      notifications: {
        noTickets: "No notifications.",
      },
      quickMessages: {
        title: "Quick Responses",
        searchPlaceholder: "Search...",
        noAttachment: "No attachment",
        confirmationModal: {
          deleteTitle: "Deletion",
          deleteMessage: "This action is irreversible! Do you wish to proceed?",
        },
        buttons: {
          add: "Add",
          attach: "Attach File",
          cancel: "Cancel",
          edit: "Edit",
        },
        toasts: {
          success: "Shortcut added successfully!",
          deleted: "Shortcut removed successfully!",
        },
        dialog: {
          title: "Quick Message",
          shortcode: "Shortcut",
          message: "Response",
          save: "Save",
          cancel: "Cancel",
          geral: "Allow editing",
          add: "Add",
          edit: "Edit",
          visao: "Allow viewing",
        },
        table: {
          shortcode: "Shortcut",
          message: "Message",
          actions: "Actions",
          mediaName: "File Name",
          status: "Status",
        },
      },
      contactLists: {
        title: "Contact Lists",
        table: {
          name: "Name",
          contacts: "Contacts",
          actions: "Actions",
        },
        buttons: {
          add: "New List",
        },
        dialog: {
          name: "Name",
          company: "Company",
          okEdit: "Edit",
          okAdd: "Add",
          add: "Add",
          edit: "Edit",
          cancel: "Cancel",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "This action cannot be undone.",
        },
        toasts: {
          deleted: "Record deleted",
        },
      },
      contactListItems: {
        title: "Contacts",
        searchPlaceholder: "Search",
        buttons: {
          add: "New",
          lists: "Lists",
          import: "Import",
        },
        dialog: {
          name: "Name",
          number: "Number",
          whatsapp: "WhatsApp",
          email: "Email",
          okEdit: "Edit",
          okAdd: "Add",
          add: "Add",
          edit: "Edit",
          cancel: "Cancel",
        },
        table: {
          name: "Name",
          number: "Number",
          whatsapp: "WhatsApp",
          email: "Email",
          actions: "Actions",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "This action cannot be undone.",
          importMessage: "Do you want to import the contacts from this sheet? ",
          importTitlte: "Import",
        },
        toasts: {
          deleted: "Record deleted",
        },
      },
      kanban: {
        title: "Kanban",
        searchPlaceholder: "Search",
        subMenus: {
          list: "Panel",
          tags: "Lanes",
        },
      },
      campaigns: {
        title: "Campaigns",
        searchPlaceholder: "Search",
        subMenus: {
          list: "List",
          listContacts: "Contact List",
          settings: "Settings",
        },
        settings: {
          randomInterval: "Random Sending Interval",
          noBreak: "No Break",
          intervalGapAfter: "Larger interval after",
          undefined: "Not defined",
          messages: "messages",
          laggerTriggerRange: "Larger sending interval",
          addVar: "Add variable",
          save: "Save",
          close: "Close",
          add: "Add",
          shortcut: "Shortcut",
          content: "Content",
        },
        buttons: {
          add: "New Campaign",
          contactLists: "Contact Lists",
        },
        table: {
          name: "Name",
          whatsapp: "Connection",
          contactList: "Contact List",
          option: "None",
          disabled: "Disabled",
          enabled: "Enabled",
          status: "Status",
          scheduledAt: "Scheduled",
          completedAt: "Completed",
          confirmation: "Confirmation",
          actions: "Actions",
        },
        dialog: {
          new: "New Campaign",
          update: "Edit Campaign",
          readonly: "View Only",
          help: "Use variables like {name}, {number}, {email}, or define custom variables.",
          form: {
            name: "Name",
            message1: "Message 1",
            message2: "Message 2",
            message3: "Message 3",
            message4: "Message 4",
            message5: "Message 5",
            confirmationMessage1: "Confirmation Message 1",
            confirmationMessage2: "Confirmation Message 2",
            confirmationMessage3: "Confirmation Message 3",
            confirmationMessage4: "Confirmation Message 4",
            confirmationMessage5: "Confirmation Message 5",
            messagePlaceholder: "Message content",
            whatsapp: "Connection",
            status: "Status",
            scheduledAt: "Scheduled",
            confirmation: "Confirmation",
            contactList: "Contact List",
            tagList: "Tags",
            statusTicket: "Ticket Status",
            openTicketStatus: "Open",
            pendingTicketStatus: "Pending",
            closedTicketStatus: "Closed",
            enabledOpenTicket: "Enabled",
            disabledOpenTicket: "Disabled",
            openTicket: "Open ticket",
          },
          buttons: {
            add: "Add",
            edit: "Update",
            okadd: "Ok",
            cancel: "Cancel Sending",
            restart: "Restart Sending",
            close: "Close",
            attach: "Attach File",
          },
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "This action cannot be undone.",
        },
        toasts: {
          success: "Operation completed successfully",
          cancel: "Campaign canceled",
          restart: "Campaign restarted",
          deleted: "Record deleted",
        },
      },
      campaignReport: {
        title: "Report of",
        inactive: "Inactive",
        scheduled: "Scheduled",
        process: "In Progress",
        cancelled: "Canceled",
        finished: "Finished",
        campaign: "Campaign",
        validContacts: "Valid Contacts",
        confirmationsRequested: "Confirmations Requested",
        confirmations: "Confirmations",
        deliver: "Delivered",
        connection: "Connection",
        contactLists: "Contact List",
        schedule: "Scheduling",
        conclusion: "Conclusion",
      },
      announcements: {
        title: "Announcements",
        searchPlaceholder: "Search",
        active: "Active",
        inactive: "Inactive",
        buttons: {
          add: "New Announcement",
          contactLists: "Announcement Lists",
        },
        table: {
          priority: "Priority",
          title: "Title",
          text: "Text",
          mediaName: "File",
          status: "Status",
          actions: "Actions",
        },
        dialog: {
          edit: "Edit Announcement",
          add: "New Announcement",
          update: "Edit Announcement",
          readonly: "View Only",
          form: {
            priority: "Priority",
            title: "Title",
            text: "Text",
            mediaPath: "File",
            status: "Status",
            high: "High",
            medium: "Medium",
            low: "Low",
            active: "Active",
            inactive: "Inactive",
          },
          buttons: {
            add: "Add",
            edit: "Update",
            okadd: "Ok",
            cancel: "Cancel",
            close: "Close",
            attach: "Attach File",
          },
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "This action cannot be undone.",
        },
        toasts: {
          success: "Operation completed successfully",
          deleted: "Record deleted",
        },
      },
      campaignsConfig: {
        title: "Campaign Settings",
      },
      queues: {
        title: "Queues & Chatbot",
        table: {
          name: "Name",
          color: "Color",
          greeting: "Greeting message",
          orderQueue: "Queue sorting (bot)",
          actions: "Actions",
          ID: "ID",
        },
        buttons: {
          add: "Add queue",
        },
        toasts: {
          success: "Queue saved successfully",
          deleted: "Queue deleted successfully",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage:
            "Are you sure? This action cannot be undone! Services in this queue will still exist but will no longer have a queue assigned.",
        },
      },
      queue: {
        queueData: "Data",
      },
      queueSelect: {
        inputLabel: "Queues",
        inputLabelRO: "Read-only queues",
        withoutQueue: "No queue",
        undefined: "Queue not found",
      },
      queueIntegration: {
        title: "Integrations",
        table: {
          id: "ID",
          type: "Type",
          name: "Name",
          projectName: "Project Name",
          language: "Language",
          lastUpdate: "Last Update",
          actions: "Actions",
        },
        buttons: {
          add: "Add Project",
        },
        searchPlaceholder: "Search...",
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage:
            "Are you sure? This action cannot be undone! It will be removed from linked queues and connections",
        },
      },
      users: {
        title: "Users",
        table: {
          status: "Status",
          name: "Name",
          email: "Email",
          profile: "Profile",
          startWork: "Work Start",
          endWork: "Work End",
          actions: "Actions",
          ID: "ID",
        },
        buttons: {
          add: "Add user",
        },
        toasts: {
          deleted: "User deleted successfully.",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage:
            "All user data will be lost. Open services from this user will be moved to the queue.",
        },
      },
      companies: {
        title: "Companies",
        table: {
          ID: "ID",
          status: "Active",
          name: "Name",
          email: "Email",
          password: "Password",
          phone: "Phone",
          plan: "Plan",
          active: "Active",
          numberAttendants: "Agents",
          numberConnections: "Connections",
          value: "Value",
          namePlan: "Plan Name",
          numberQueues: "Queues",
          useCampaigns: "Campaigns",
          useExternalApi: "Rest API",
          useFacebook: "Facebook",
          useInstagram: "Instagram",
          useWhatsapp: "WhatsApp",
          useInternalChat: "Internal Chat",
          useSchedules: "Scheduling",
          createdAt: "Created At",
          dueDate: "Due Date",
          lastLogin: "Last Login",
          actions: "Actions",
          money: "$",
          yes: "Yes",
          no: "No",
          document: "CNPJ/CPF",
          recurrence: "Recurrence",
          monthly: "Monthly",
          bimonthly: "Bimonthly",
          quarterly: "Quarterly",
          semester: "Semiannual",
          yearly: "Annual",
          clear: "Clear",
          delete: "Delete",
          user: "User",
          save: "Save",
        },
        buttons: {
          add: "Add company",
        },
        toasts: {
          deleted: "Company deleted successfully.",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage:
            "All company data will be lost. Open tickets from this user will be moved to the queue.",
        },
      },
      plans: {
        form: {
          name: "Name",
          users: "Users",
          connections: "Connections",
          campaigns: "Campaigns",
          schedules: "Schedules",
          enabled: "Enabled",
          disabled: "Disabled",
          clear: "Cancel",
          delete: "Delete",
          save: "Save",
          yes: "Yes",
          no: "No",
          money: "$",
          public: "Public"
        },
      },
      helps: {
        title: "Help Center",
        settings: {
          codeVideo: "Video Code",
          description: "Description",
          clear: "Clear",
          delete: "Delete",
          save: "Save",
        },
      },
      schedules: {
        title: "Schedules",
        confirmationModal: {
          deleteTitle: "Are you sure you want to delete this Schedule?",
          deleteMessage: "This action cannot be undone.",
        },
        table: {
          contact: "Contact",
          body: "Message",
          sendAt: "Schedule Date",
          sentAt: "Sent Date",
          status: "Status",
          actions: "Actions",
        },
        buttons: {
          add: "New Schedule",
        },
        toasts: {
          deleted: "Schedule deleted successfully.",
        },
      },
      tags: {
        title: "Tags",
        confirmationModal: {
          deleteTitle: "Are you sure you want to delete this Tag?",
          deleteMessage: "This action cannot be undone.",
        },
        table: {
          id: "ID",
          name: "Name",
          kanban: "Kanban",
          color: "Color",
          tickets: "Tag Records",
          contacts: "Contacts",
          actions: "Actions",
        },
        buttons: {
          add: "New Tag",
        },
        toasts: {
          deleted: "Tag deleted successfully.",
        },
      },
      tagsKanban: {
        title: "Lanes",
        laneDefault: "Open",
        confirmationModal: {
          deleteTitle: "Are you sure you want to delete this Lane?",
          deleteMessage: "This action cannot be undone.",
        },
        table: {
          name: "Name",
          color: "Color",
          tickets: "Tickets",
          actions: "Actions",
        },
        buttons: {
          add: "New Lane",
        },
        toasts: {
          deleted: "Lane deleted successfully.",
        },
      },
      files: {
        title: "File List",
        table: {
          name: "Name",
          contacts: "Contacts",
          actions: "Action",
        },
        toasts: {
          deleted: "List deleted successfully!",
          deletedAll: "All lists deleted successfully!",
        },
        buttons: {
          add: "Add",
          deleteAll: "Delete All",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteAllTitle: "Delete All",
          deleteMessage: "Are you sure you want to delete this list?",
          deleteAllMessage: "Are you sure you want to delete all lists?",
        },
      },
      settings: {
        success: "Settings saved successfully.",
        title: "Settings",
        tabs: {
          options: "Options",
          plans: "Plans",
          helps: "Help",
        },
        settings: {
          userCreation: {
            name: "User creation",
            options: {
              enabled: "Enabled",
              disabled: "Disabled",
            },
          },
          tabs: {
            options: "Options",
            schedules: "Schedules",
            plans: "Plans",
            help: "Help",
          },
          options: {
            disabled: "Disabled",
            enabled: "Enabled",
            updating: "Updating...",
            creationCompanyUser: "Company/User Creation",
            evaluations: "Evaluations",
            officeScheduling: "Office Scheduling",
            queueManagement: "Queue Management",
            companyManagement: "Company Management",
            connectionManagement: "Connection Management",
            sendGreetingAccepted: "Send greeting upon accepting ticket",
            sendMsgTransfTicket:
              "Send transfer message for department/agent",
            checkMsgIsGroup: "Ignore Group Messages",
            chatBotType: "Bot Type",
            userRandom: "Choose random agent",
            buttons: "Buttons",
            acceptCallWhatsapp: "Inform that calls are not accepted on WhatsApp?",
            sendSignMessage: "Allow agent to choose SEND Signature",
            sendGreetingMessageOneQueues:
              "Send greeting when there is only one queue",
            sendQueuePosition: "Send message with queue position",
            sendFarewellWaitingTicket:
              "Send farewell message in Waiting",
            acceptAudioMessageContact:
              "Accept audio from all contacts?",
            enableLGPD: "Enable LGPD handling",
            requiredTag: "Mandatory tag to close ticket",
            closeTicketOnTransfer: "Close ticket when transferring to another queue",
            DirectTicketsToWallets: "Automatically move client to wallet",
            showNotificationPending: "Show notification for pending tickets",
            asaasApiKey: "Asaas API Key",
            asaasApiKeyHelp: "Asaas API key for issuing slips (second copy)"
          },
          customMessages: {
            sendQueuePositionMessage: "Queue position message",
            AcceptCallWhatsappMessage: "Message to inform calls are not accepted",
            greetingAcceptedMessage: "Greeting message upon accepting ticket",
            transferMessage: "Transfer message - ${queue.name} = destination queue",
          },
          LGPD: {
            title: "LGPD",
            welcome: "Welcome message (LGPD)",
            linkLGPD: "Privacy policy link",
            obfuscateMessageDelete: "Hide deleted message",
            alwaysConsent: "Always request consent",
            obfuscatePhoneUser: "Hide phone number for users",
            enabled: "Enabled",
            disabled: "Disabled",
          },
        },
      },
      messagesList: {
        header: {
          assignedTo: "Assigned to:",
          dialogRatingTitle:
            "Would you like to leave a service rating for the client?",
          dialogClosingTitle: "Closing the service with the client!",
          dialogRatingCancel: "Resolve WITH Farewell Message",
          dialogRatingSuccess: "Resolve and Send Rating",
          dialogRatingWithoutFarewellMsg: "Resolve WITHOUT Farewell Message",
          ratingTitle: "Choose a rating menu",
          notMessage: "No message selected",
          amount: "Prospecting value",
          buttons: {
            return: "Return",
            resolve: "Resolve",
            reopen: "Reopen",
            accept: "Accept",
            rating: "Send Rating",
            enableIntegration: "Enable integration",
            disableIntegration: "Disable integration",
            logTicket: "Ticket Logs",
            requiredTag: "You must assign a tag before closing the ticket.",
          },
        },
      },
      messagesInput: {
        placeholderPrivateMessage:
          "Type a message or press / for quick responses",
        placeholderOpen:
          "Type a message or press / for quick responses",
        placeholderClosed:
          "Reopen or accept this ticket to send a message.",
        signMessage: "Sign",
        privateMessage: "Private Message",
      },
      contactDrawer: {
        header: "Contact details",
        buttons: {
          edit: "Edit contact",
          block: "Block",
          unblock: "Unblock",
        },
        extraInfo: "Other information",
      },
      messageVariablesPicker: {
        label: "Available variables",
        vars: {
          contactFirstName: "First Name",
          contactName: "Name",
          user: "Agent",
          greeting: "Greeting",
          protocolNumber: "Protocol",
          date: "Date",
          hour: "Hour",
          ticket_id: "Ticket Number",
          queue: "Department",
          connection: "Connection",
        },
      },
      ticketOptionsMenu: {
        schedule: "Schedule",
        delete: "Delete",
        transfer: "Transfer",
        registerAppointment: "Contact Notes",
        resolveWithNoFarewell: "Close without farewell",
        acceptAudioMessage: "Accept audios from contact?",
        appointmentsModal: {
          title: "Ticket Notes",
          textarea: "Note",
          placeholder: "Enter the information you want to record here",
        },
        confirmationModal: {
          title: "Delete the contact's ticket",
          titleFrom: "from contact ",
          message:
            "Attention! All messages related to the ticket will be lost.",
        },
        buttons: {
          delete: "Delete",
          cancel: "Cancel",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancel",
        },
      },
      messageInput: {
        tooltip: {
          signature: "Enable/Disable Signature",
          privateMessage: "Enable/Disable Private Message",
          meet: "Send link for video conference",
        },
        type: {
          imageVideo: "Photos and videos",
          cam: "Camera",
          contact: "Contact",
          meet: "Video call",
        },
      },
      messageOptionsMenu: {
        delete: "Delete",
        reply: "Reply",
        edit: "Edit",
        forward: "Forward",
        toForward: "Forward",
        talkTo: "Talk To",
        react: "React",
        confirmationModal: {
          title: "Delete message?",
          message: "This action cannot be undone.",
        },
      },
      invoices: {
        table: {
          invoices: "Invoices",
          details: "Details",
          users: "Users",
          connections: "Connections",
          queue: "Queues",
          value: "Value",
          expirationDate: "Due Date",
          action: "Action",
        },
      },
      backendErrors: {
        ERR_NO_OTHER_WHATSAPP: "There must be at least one default WhatsApp.",
        ERR_NO_DEF_WAPP_FOUND:
          "No default WhatsApp found. Check the connections page.",
        ERR_WAPP_NOT_INITIALIZED:
          "This WhatsApp session was not initialized. Check the connections page.",
        ERR_WAPP_CHECK_CONTACT:
          "Could not verify WhatsApp contact. Check the connections page",
        ERR_WAPP_INVALID_CONTACT: "This is not a valid WhatsApp number.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "Could not download media from WhatsApp. Check the connections page.",
        ERR_INVALID_CREDENTIALS:
          "Authentication error. Please try again.",
        ERR_SENDING_WAPP_MSG:
          "Error sending WhatsApp message. Check the connections page.",
        ERR_DELETE_WAPP_MSG: "Could not delete the WhatsApp message.",
        ERR_OTHER_OPEN_TICKET: "There is already an open ticket for this contact.",
        ERR_SESSION_EXPIRED: "Session expired. Please log in.",
        ERR_USER_CREATION_DISABLED:
          "User creation was disabled by the administrator.",
        ERR_NO_PERMISSION: "You do not have permission to access this resource.",
        ERR_DUPLICATED_CONTACT: "A contact with this number already exists.",
        ERR_NO_SETTING_FOUND: "No setting found with this ID.",
        ERR_NO_CONTACT_FOUND: "No contact found with this ID.",
        ERR_NO_TICKET_FOUND: "No ticket found with this ID.",
        ERR_NO_USER_FOUND: "No user found with this ID.",
        ERR_NO_WAPP_FOUND: "No WhatsApp found with this ID.",
        ERR_CREATING_MESSAGE: "Error creating message in the database.",
        ERR_CREATING_TICKET: "Error creating ticket in the database.",
        ERR_FETCH_WAPP_MSG:
          "Error fetching the message from WhatsApp; it may be too old.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "This color is already in use; choose another.",
        ERR_WAPP_GREETING_REQUIRED:
          "The greeting message is mandatory when there is more than one queue.",
        ERR_OUT_OF_HOURS: "Outside Business Hours!",
      },
    }
  }
};

export { messages };
